// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"a10a3f92e9--tooltip--Ws8gP"};